import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Modal from "../../../components/Modal";
import { formatDate, formatToZMW, handlePrint, rootUrl, sumOfArray } from "../../../helpers";
import { useAuth } from "../../../context/auth-context";
import AddBillModal from "./addBill";
import { useOutletContext } from 'react-router-dom';
import DataTable from "react-data-table-component";
import { FaArrowAltCircleDown, FaArrowAltCircleLeft, FaEye, FaFile, FaHome, FaList, FaPlus, FaPrint, FaSpinner, FaToggleOn, FaSearch, FaFilter, FaTimes, FaMoneyBill } from "react-icons/fa";
import { collapse } from "@material-tailwind/react";
import FormGenerator from "../../../components/formGenerator";
import { toast } from "react-toastify";
import { FaFileLines } from "react-icons/fa6";
import { PiInvoice } from "react-icons/pi";
import { customStyles } from "../../../styles";
import PayForm from "./form";
import ActualBills from "./actualBills";

const Bills = () => {
  const [bills, setBills] = useState([]);
  const [searchQuery, setSearchQuery] = useState(''); 
  const [recs, setRecs] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [showBillModal, setShowBillModal] = useState(false);
  const [showAddBillModal, setShowAddBillModal] = useState(false);
  const [selectedBill, setSelectedBill] = useState([]);
  const [actualBill, setActualBill] = useState([]);
  const [property, setProperty] = useState([]);
  const [statement, setStatement] = useState([]);
  const [makePayment, setMakePayment] = useState(false);
  const [activeTab, setActiveTab] = useState('customers'); // Add state for tab selection

  const auth = useAuth();
  // const { dept, coa ,program ,subProgram, bank, cc, sof  } = useOutletContext();
  const {allData, setAllData} = useOutletContext();

  // Fetch Bill
  useEffect(() => {
    fetchBills();
  }, []);

  const fetchBills = async () => {
    try {
      const response = await axios.get(rootUrl(`/bills/${auth.user.id}`));
      if(response.data.status === 200){
        setBills(response.data.data);
      }else{
        toast.error("Error fetching bills")
      }
    
    } catch (error) {
      console.error("Error fetching bills:", error);
    }
  };



  const filteredData = bills?.length > 0? bills.filter(customer =>
    customer.name?.toLowerCase().includes(searchQuery?.toLowerCase()) 
  ):[]

  const handleViewBill = async (customer) => {
    try {
      const response = await axios.get(rootUrl(`/bill/${customer}`));
      setSelectedBill(response.data.bills);
      setRecs(response.data.recs);
      setProperty(response.data.property)
      setShowBillModal(true);

      const billz = response.data.bills.map((bill) => ({
        ...bill,
        type: "Bill",
        date: new Date(bill.date),
      }));
  
      const receipts = response.data.recs.map((rec) => ({
        ...rec,
        type: "Receipt",
        date: new Date(rec.date),
      }));
  
      // Merge and sort by date
      const combined = [...billz, ...receipts].sort((a, b) => a.date - b.date);
      setStatement(combined);

    } catch (error) {
      console.error("Error fetching bill details:", error);
    }
  };

  const handleAddBill = () => {
    setShowAddBillModal(true);
  };

  const totalOutstanding = bills.reduce((sum, row) => sum + parseFloat(row.amount), 0);

  const columns = [
    {
        name: "Sn",
        selector: (row, index) => index + 1,
        sortable: true,
        width: "50px",
    },
    {
        name: "Customer",
        selector: (row) => `${row.name}`,
        sortable: true,
    },
    {
        name: "Outstanding",
        selector: (row) => formatToZMW(row.amount),
        sortable: true,
    },
    {
        name: "Actions",
        cell: (row) => (
            <button
                onClick={() => handleViewBill(row.customer)}
                className="p-2 bg-blue-100 hover:bg-blue-200 text-blue-700 rounded-lg transition-colors"
                title="View Bill"
            >
                <FaEye className="text-sm" />
            </button>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
    },
];

const [isDebit, setIsDebit] = useState(true)

const [items, setItems] = useState([])
const [itemGroup, setItemGroup] = useState([])
const showActBill = (obj, isDeb) =>{
  setToggle(true)
  setIsDebit(isDeb)
  const matchKey = isDeb ? obj.invoice_no : obj.receipt_no
  const grouped = statement.filter(entry => {
    if (isDeb) {
      if (!matchKey) {
        return entry.type === "Bill" && entry.b_id === obj.b_id
      }
      return entry.type === "Bill" && entry.invoice_no === matchKey
    }
    if (!matchKey) {
      return entry.type === "Receipt" && entry.id === obj.id
    }
    return entry.type === "Receipt" && entry.receipt_no === matchKey
  })
  const normalizedGroup = grouped.length > 0 ? grouped : [obj]
  setItemGroup(normalizedGroup)
  setItems(normalizedGroup[0] || obj)

}

const fields = [
  {type: 'select', name: 'billID', label: 'Bill', required: true, options:
    selectedBill?.map((res)=>({
      value:res.b_id,
      label:`${allData.budget?.find(a=>a.id === res.coa_id)?.coa}`
    }))
  },
  {type: 'select', name: 'type', label: 'Type', required: true, options:[
    {value:1, label:'Payment'},
    {value:2, label:'Credit note'},
  ]},
  {type: 'text', name: 'amount', label: 'Amount', required: true},
  {type: 'text', name: 'description', label: 'Description', required: true},
]

const onSubmitForm = async (formdata)=>{

  formdata['uid'] = auth.user.id
  formdata['billID'] = selectedBill[0]?.b_id
  
  try{

    const response = await axios.post(rootUrl('/addPayment'), formdata)

    if(response.data.status === 200){
      toast.success("Submitted successfully")
      setMakePayment(false)
      handleViewBill(selectedBill[0].customer)
    }else{
      toast.error("Something went wrong")
    }


  }catch(e){
    toast.error(e?.message)
  }

}

const handleFormSubmit = async (payload) => {

  payload['uid'] = auth.user.id
  try{
      const response = await axios.post(rootUrl('/addBill'), payload)
      if(response.data.status === 200){
          toast.success("Submitted successfully")
          setShowAddBillModal(false)
          fetchBills()
      }else{
          toast.error("Something went wrong")
      }

  }catch(e){
      toast.error(e?.message)
  }
};

const componentRef = useRef(null)



  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-950 to-blue-800 rounded-2xl p-6 text-white shadow-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="bg-white/20 rounded-xl p-3">
              <PiInvoice className="text-2xl" />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold">Bills Management</h1>
              <p className="text-blue-100 text-sm mt-1">Manage customer bills, view statements and record payments</p>
            </div>
          </div>
        </div>
      </div>

      {/* Top navigation tabs */}
      <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-2">
        <div className="inline-flex rounded-lg bg-gray-100 p-1">
          <button
            className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg transition-all ${
              activeTab === 'customers'
                ? 'bg-gradient-to-r from-blue-950 to-blue-800 text-white shadow-md scale-105'
                : 'text-gray-700 hover:bg-white'
            }`}
            onClick={() => setActiveTab('customers')}
          >
            <FaList />
            <span>Customers</span>
          </button>
          <button
            className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg transition-all ${
              activeTab === 'bills'
                ? 'bg-gradient-to-r from-blue-950 to-blue-800 text-white shadow-md scale-105'
                : 'text-gray-700 hover:bg-white'
            }`}
            onClick={() => setActiveTab('bills')}
          >
            <PiInvoice />
            <span>Bills</span>
          </button>
        </div>
      </div>

      {activeTab === 'customers' ? (
        <>
          {/* Action Button */}
          <div className="flex justify-end">
            <button
              onClick={handleAddBill}
              className="flex items-center gap-2 px-4 py-2.5 bg-gradient-to-r from-blue-950 to-blue-800 text-white rounded-lg hover:shadow-lg transition-all font-medium shadow-sm"
            >
              <FaPlus />
              <span>Add Bill</span>
            </button>
          </div>

          {/* Search + summary */}
          <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
            <div className="flex flex-col md:flex-row md:items-end gap-4">
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <div className="flex items-center gap-2">
                    <FaSearch className="text-gray-500 text-sm" />
                    <span>Search Customers</span>
                  </div>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaSearch className="h-4 w-4 text-gray-400" />
                  </div>
                  <input
                    type="text"
                    placeholder="Search customers..."
                    value={searchQuery}
                    onChange={e => setSearchQuery(e.target.value)}
                    className="w-full pl-10 pr-10 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                  />
                  {searchQuery && (
                    <button
                      onClick={() => setSearchQuery('')}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors"
                    >
                      <FaTimes className="h-4 w-4" />
                    </button>
                  )}
                </div>
              </div>
              <div className="flex-shrink-0">
                <div className="bg-white px-4 py-2.5 rounded-lg border border-gray-300 text-sm text-gray-700 font-medium">
                  Total: {filteredData.length} customer{filteredData.length === 1 ? "" : "s"}
                </div>
              </div>
            </div>
          </div>

          {/* Data table wrapper */}
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
            <DataTable
              title=""
              columns={columns}
              data={filteredData}
              pagination
              highlightOnHover
              striped
              responsive
              customStyles={customStyles}
            />
          </div>

          <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 text-right">
            <span className="text-sm font-medium text-gray-700">Total Outstanding: </span>
            <span className="text-lg font-bold text-blue-950">
              {formatToZMW(totalOutstanding)}
            </span>
          </div>

          {/* View Bill Modal */}
          {showBillModal && (
            <Modal title="View Bill" onClose={() => setShowBillModal(false)}>
              {selectedBill ? (
                <>
                  <div className="flex items-center justify-between mb-4 pb-4 border-b border-gray-200">
                    {toggle ? (
                      <button
                        onClick={() => setToggle(false)}
                        className="inline-flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg text-sm font-medium transition-colors"
                      >
                        <FaArrowAltCircleLeft />
                        <span>Back to statement</span>
                      </button>
                    ) : (
                      <div />
                    )}
                    <button
                      onClick={() => handlePrint(componentRef)}
                      className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-950 to-blue-800 text-white px-4 py-2 rounded-lg text-sm font-medium hover:shadow-lg transition-all"
                    >
                      <FaPrint />
                      <span>Print</span>
                    </button>
                  </div>

                  <div ref={componentRef} className="bg-white rounded-lg border border-gray-200 p-3 md:p-4">
                    {toggle ? (
                      <PropertyRatesBill
                        items={items}
                        itemGroup={itemGroup}
                        allData={allData}
                        showActBill={showActBill}
                        isDebit={isDebit}
                        property={property}
                      />
                    ) : (
                      <AllRatesBill
                        statement={statement}
                        selectedBill={selectedBill}
                        allData={allData}
                        showActBill={showActBill}
                        property={property}
                      />
                    )}
                  </div>

                  <div className="mt-6 pt-4 border-t border-gray-200">
                    {toggle && (
                      <button
                        className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-gradient-to-r from-blue-950 to-blue-800 text-white text-sm font-medium hover:shadow-lg transition-all"
                        onClick={() => setMakePayment(!makePayment)}
                      >
                        <FaPlus />
                        <span>{makePayment ? "Close Payment" : "Add Payment"}</span>
                      </button>
                    )}

                    {makePayment && toggle && (
                      <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
                        <div className="flex items-center gap-2 mb-4">
                          <FaMoneyBill className="text-blue-600" />
                          <span className="font-bold text-lg text-gray-900">Make Payment</span>
                        </div>
                        <PayForm
                          data={itemGroup}
                          allData={allData}
                          onSubmitForm={onSubmitForm}
                        />
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <div className="flex items-center justify-center py-10">
                  <FaSpinner size={32} className="animate-spin text-blue-950" />
                </div>
              )}
            </Modal>
          )}

          {/* Add Bill Modal */}
          {showAddBillModal && (
            <Modal title="Add New Bill" onClose={() => setShowAddBillModal(false)}>
              <AddBillModal data={allData} onSubmit={handleFormSubmit} type={1} />
            </Modal>
          )}
        </>
      ) : (
        <ActualBills />
      )}
    </div>
  );
};



const PropertyRatesBill = ({items, itemGroup = [], allData, openingBalance, property, isDebit}) => {
  function getHalfOfYear(date) {
    const month = new Date(date).getMonth() + 1; // getMonth() is zero-based
    return month <= 6 ? "January to June" : "July to December";
  }

  const normalizedItems = itemGroup.length > 0 ? itemGroup : (items ? [items] : [])
  const primaryItem = normalizedItems[0] || items || {}

  const prt = property.find(a=>a.id == primaryItem.pid)


 let overall = 0
  return (
    <div className="max-w-3xl mx-auto p-6 border rounded-lg shadow-lg">
      <div className="flex justify-center">
      <img  className='w-[150px]' src={rootUrl(`/${allData?.council[0]?.path}`)} alt="Council Logo" />
      </div>
     
      <h2 className="text-xl font-bold text-center">{allData?.council[0]?.name}</h2>
      <h3 className="text-lg font-semibold text-center mt-2">{isDebit?prt?'PROPERTY RATES BILL':'INVOICE':'RECEIPT'}</h3>

    {
      isDebit && prt?
      <div className="grid grid-cols-2 gap-6 mt-6 p-4 border border-gray-300 bg-white">
      <div className="space-y-2">
      <p className="text-gray-700"><span className="font-semibold"> Owner:</span> <span>{items?.name}</span></p>

    <p className="text-gray-700"><span className="font-semibold">HSE No and Street:</span> <span>{prt?.street} {prt?.property_no}</span></p>
    <p className="text-gray-700"><span className="font-semibold">Town and Zone:</span> <span>{prt?.location}</span></p>
    <p className="text-gray-700"><span className="font-semibold">Description:</span> <span>{prt?.description}</span></p>
  </div>

   

    <div className="space-y-2">
      <p className="text-gray-700"><span className="font-semibold">Improve Value:</span> <span>{prt?.improvements}</span></p>
      <p className="text-gray-700"><span className="font-semibold">Land Value:</span> <span>{prt?.land_value}</span></p>

      <p className="text-gray-700"><span className="font-semibold">Rate Used:</span> <span>{parseFloat(prt?.annual_payable) / 2}</span></p>
      <p className="text-gray-700"><span className="font-semibold">Reference No.:</span> <span>{items?.invoice_no}</span></p>
      <p className="text-gray-700"><span className="font-semibold">Hectares .:</span> <span>{parseFloat(prt?.land_ext) == 0.0 ? '':prt?.land_ext}</span></p>
     
    </div>
</div>
:
<div className="grid grid-cols-2 gap-6 mt-6 p-4 border border-gray-300 bg-white">
      <p className="text-gray-700"><span className="font-semibold"> Customer:</span> <span>{isDebit?primaryItem?.name:allData.suppliers.find(a=>a.id == primaryItem.cust)?.name}</span></p>
      <p className="text-gray-700"><span className="font-semibold">{isDebit?'Invoice No:':'Receipt No:'} </span> <span>{isDebit?primaryItem?.invoice_no:primaryItem?.receipt_no}</span></p>
</div>
    }
{
  isDebit?

  <table className="w-full mt-4 border-collapse border border-gray-300">
  <thead>
    <tr className="bg-blue-950 text-white">
      <th className="border border-gray-300 p-2">Date</th>
      <th className="border border-gray-300 p-2">Description</th>
      <th className="border border-gray-300 p-2">Balance B/F</th>
      <th className="border border-gray-300 p-2"> Amount </th>
      <th className="border border-gray-300 p-2">Closing Amount</th>
    </tr>
  </thead>
  <tbody>
  {(() => {
    let runningBalance = parseFloat(prt?.opening || 0)
    return normalizedItems.map((entry, idx) => {
      const amount = parseFloat(entry.amount || 0)
      const balanceBF = idx === 0 ? runningBalance : runningBalance
      runningBalance += amount
      const coaLabel = allData.budget?.find(a=>a.id === entry.coa_id)?.coa
      const coaName = allData.coa?.find(a=>a.account === coaLabel)?.name
      if (idx === normalizedItems.length - 1) {
        overall = runningBalance
      }
      return (
        <tr className="" key={`${entry.b_id || entry.id}-${idx}`}>
          <td className="border border-gray-300 p-2">{formatDate(entry.date.toString())}</td>
          <td className="border border-gray-300 p-2">
            {coaLabel} : {coaName}
          </td>
          <td className="border border-gray-300 p-2">{balanceBF}</td>
          <td className="border border-gray-300 p-2"> {amount} </td>
          <td className="border border-gray-300 p-2">{runningBalance}</td>
        </tr>
      )
    })
  })()}
  </tbody>
</table>

:

<table className="w-full mt-4 border-collapse border border-gray-300">
<thead>
  <tr className="bg-blue-950 text-white">
    <th className="border border-gray-300 p-2">Date</th>
    <th className="border border-gray-300 p-2">Description</th>
    <th className="border border-gray-300 p-2"> Amount </th>
  </tr>
</thead>
<tbody>
{normalizedItems.map((entry, idx) => (
  <tr className="" key={`${entry.id || entry.b_id}-${idx}`}>
      <td className="border border-gray-300 p-2">{formatDate(entry.date.toString())}</td>
      <td className="border border-gray-300 p-2">
      {entry.description}
      </td>
      <td className="border border-gray-300 p-2"> {entry.amount} </td>
    </tr>
))}
</tbody>
</table>
}
    

{
  isDebit?
  <div className="mt-4">
  <p><strong>Amount Due (ZMK):</strong>{overall || parseFloat(prt?.opening || 0)}</p>
</div>:
null
}
      <hr className="my-5" />

      <div className="grid grid-cols-2 gap-4">
        <div>
        <p><strong>Issued By:</strong> {isDebit?'__________________':allData.users.find(a=>a.u_id == items.issuer)?.firstname +' '+allData.users.find(a=>a.u_id == items.issuer)?.lastname} </p>
        <p><strong>Signature:</strong> __________________</p>
        </div>
        <div>
        <p><strong>Received By:</strong> _________________</p>
        <p><strong>Signature:</strong> ___________________</p>
        </div>
       
      </div>

{/* <hr className="my-5" /> */}
      {/* <div className="mt-4">
        <h3 className="text-lg font-semibold">Payment Details</h3>

        <div className="grid grid-cols-2 gap-4">
          <div>
          <p className="mt-2"><strong>Bank Name:</strong> {allData.bank[0]?.name.split("-")[1]}</p>
          <p><strong>Account Name:</strong> {allData.bank[0]?.name.split("-")[0]}</p>
          <p><strong>Account #:</strong> {allData.bank[0]?.account_no}</p>
          <p><strong>Branch:</strong> </p>
          </div>
          <div>
          <p className="mt-2"><strong>Bank Name:</strong> {allData.bank[1]?.name.split("-")[1]}</p>
          <p><strong>Account Name:</strong> {allData.bank[1]?.name.split("-")[0]}</p>
          <p><strong>Account #:</strong> {allData.bank[1]?.account_no}</p>
          <p><strong>Branch:</strong> </p>
          </div>

        </div>
        
        
      </div> */}
    </div>
  );
};

const AllRatesBill = ({statement, selectedBill, allData, property, showActBill}) => {
  function getHalfOfYear(date) {
    const month = new Date(date).getMonth() + 1; // getMonth() is zero-based
    return month <= 6 ? "January to June" : "July to December";
  }

 let overall = 0

 const open = sumOfArray(property.map((res)=>parseFloat(res.opening)))

  // Age analysis logic
  const today = new Date();
  const ageBuckets = [
    { label: '0-30 days', min: 0, max: 30 },
    { label: '31-60 days', min: 31, max: 60 },
    { label: '61-90 days', min: 61, max: 90 },
    { label: '91+ days', min: 91, max: Infinity }
  ];
  // Get unpaid bills only (type === 'Bill' and not offset by a receipt)
  const unpaidBills = statement.filter(item => item.type === 'Bill' && !statement.some(r => r.type === 'Receipt' && r.b_id === item.b_id && r.amount === item.amount));
  // Sum amounts in each age bucket
  const ageAnalysis = ageBuckets.map(bucket => {
    let sum = unpaidBills.reduce((acc, bill) => {
      const billDate = bill.date ? new Date(bill.date) : null;
      console.log(bill)
      console.log(statement)
      if (!billDate) return acc;
      const age = Math.floor((today - billDate) / (1000 * 60 * 60 * 24));
      if (age >= bucket.min && age <= bucket.max) {
        // Find matching receipts for this bill item
        const receipts = statement.filter(r => r.type === 'Receipt' && r.b_id === bill.b_id);
        const receiptsTotal = receipts.reduce((racc, r) => racc + parseFloat(r.amount), 0);
        const unpaidAmount = parseFloat(bill.amount) - receiptsTotal;
        return unpaidAmount > 0 ? acc + unpaidAmount : acc;
      }
      return acc;
    }, 0);
    // Add opening balance to 91+ days bucket
    if (bucket.label === '91+ days') {
      sum += open;
    }
    return { ...bucket, sum };
  });

  return (
    <div className="max-w-3xl mx-auto p-6 border rounded-lg shadow-lg">
      <div className="flex justify-center">
      <img  className='w-[150px]' src={rootUrl(`/${allData?.council[0]?.path}`)} alt="Council Logo" />
      </div>
     
      <h2 className="text-xl font-bold text-center">{allData?.council[0]?.name}</h2>
      <h3 className="text-lg font-semibold text-center mt-2">Customer Statment</h3>
      <h3 className="text-lg font-semibold text-center mt-2">{selectedBill[0]?.name}</h3>
      <table className="w-full mt-4 border-collapse border border-gray-300">
        <thead>
          <tr className="bg-blue-950 text-white">
            <th className="border border-gray-300 p-2">Date</th>
            <th className="border border-gray-300 p-2">Property</th>
            <th className="border border-gray-300 p-2">Period</th>
            <th className="border border-gray-300 p-2">Account No</th>
            <th className="border border-gray-300 p-2">Type</th>
            <th className="border border-gray-300 p-2">Ref No.</th>
            <th className="border border-gray-300 p-2"> Amount</th>
            <th className="border border-gray-300 p-2"> Balance</th>

          </tr>
        </thead>
        <tbody>
        <tr className="bg-white">
            <td className="border border-gray-300 p-2">2025-01-01</td>
            <td className="border border-gray-300 p-2"></td>
            <td className="border border-gray-300 p-2"></td>
            <td className="border border-gray-300 p-2"></td>
            <td className="border border-gray-300 p-2">Opening Balance</td>
            <td className="border border-gray-300 p-2"> {open}</td>
            <td className="border border-gray-300 p-2"> {open}</td>

          </tr>
        {statement.reduce(
    (acc, item, index) => {
   
      const isDebit = item.type === "Bill";
      const amount = parseFloat(item.amount);
      const pty = property.find(a=>a.id == item.pid)
      if (index === 0) {
        acc.cumulativeBalance += open; // Add opening balance only once
      }
  
      // Update cumulative balance
      const newBalance = isDebit
        ? acc.cumulativeBalance + amount
        : acc.cumulativeBalance - amount;
  
      // Push the current row with updated values
      acc.rows.push(
        <tr
          key={index}
          className={index % 2 === 0 ? "bg-gray-100" : "bg-white"}
          onClick={()=>showActBill(item, isDebit)}
        >
          <td className="px-4 py-2 border">
            {(item.date.toISOString().substring(0, 10))}
          </td>
         
          <td className="px-4 py-2 border">{pty?.property_no}  {pty?.description}</td>
          <td className="px-4 py-2 border">{getHalfOfYear(item.date)}</td>
          <td className="px-4 py-2 border">
          
            {
              isDebit?
              <>
                {allData.budget?.find(a=>a.id === item.coa_id)?.coa} : 
                {allData.coa?.find(a=>a.account === allData.budget?.find(a=>a.id === item.coa_id)?.coa)?.name}
              </>
              :
              <>
                {allData.budget?.find(a=>a.id === selectedBill?.find(a=>a.id === item.b_id)?.coa_id)?.coa} : 
                {allData.coa?.find(a=>a.account === allData.budget?.find(a=>a.id === selectedBill?.find(a=>a.id === item.b_id)?.coa_id)?.coa)?.name}
              </>
            }
            
          </td>
          <td className="px-4 py-2 border">
            {isDebit ? "Bill": "Receipt"}
          </td>
          <td className="px-4 py-2 border">
            {isDebit ? (item.invoice_no || '-') : (item.receipt_no || '-')}
          </td>
          {/* <td className="px-4 py-2 border">
            {isDebit ? formatToZMW(openingBalance) : ""}
          </td> */}
         
          <td className="px-4 py-2 border">
            {isDebit ? formatToZMW(amount) : -(amount)}
            
          </td>
          {/* <td className="px-4 py-2 border">
            {!isDebit ? formatToZMW(amount) : ""}
          </td> */}
          <td className="px-4 py-2 border">
            {formatToZMW(newBalance)}
          </td>
        </tr>
      );

      // Update cumulative balance for the next row
      acc.cumulativeBalance = newBalance;
      overall = newBalance
      return acc;
    },
    { rows: [], cumulativeBalance: 0 } // Initial state
        ).rows}
        </tbody>
      </table>

      <div className="mt-4">
        <p><strong>Amount Due (ZMK):</strong>{overall}</p>
      </div>
      {/* Age Analysis Table */}
      <div className="mt-6">
        <h4 className="font-semibold mb-2">Age Analysis (Unpaid Bills)</h4>
        <table className="w-full border border-gray-300">
          <thead>
            <tr className="bg-blue-950 text-white">
              {ageBuckets.map(bucket => (
                <th key={bucket.label} className="border p-2">{bucket.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {ageAnalysis.map(a => (
                <td key={a.label} className="border p-2 text-right">{a.sum}</td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>

      <hr className="my-5" />

      <div className="grid grid-cols-2 gap-4">
        <div>
        <p><strong>Issued By:</strong> __________________</p>
        <p><strong>Signature:</strong> __________________</p>
        </div>
        <div>
        <p><strong>Received By:</strong> _________________</p>
        <p><strong>Signature:</strong> ___________________</p>
        </div>
       
      </div>

{/* <hr className="my-5" /> */}
      {/* <div className="mt-4">
        <h3 className="text-lg font-semibold">Payment Details</h3>

        <div className="grid grid-cols-2 gap-4">
          <div>
          <p className="mt-2"><strong>Bank Name:</strong> {allData.bank[0]?.name.split("-")[1]}</p>
          <p><strong>Account Name:</strong> {allData.bank[0]?.name.split("-")[0]}</p>
          <p><strong>Account #:</strong> {allData.bank[0]?.account_no}</p>
          <p><strong>Branch:</strong> </p>
          </div>
          <div>
          <p className="mt-2"><strong>Bank Name:</strong> {allData.bank[1]?.name.split("-")[1]}</p>
          <p><strong>Account Name:</strong> {allData.bank[1]?.name.split("-")[0]}</p>
          <p><strong>Account #:</strong> {allData.bank[1]?.account_no}</p>
          <p><strong>Branch:</strong> </p>
          </div>

        </div>
        
        
      </div> */}
    </div>
  );
};

export default Bills;
